// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogpostTightContent_wrapper__SfXqG","container":"BlogpostTightContent_container__SnTMR"};